import { useMemo } from 'react'
import { useFlag } from './flags'

export const useFolderTerm = () => {
  const isNestedProjectsOn = useFlag('nested-projects')

  return useMemo(
    () =>
      ({
        upper: isNestedProjectsOn ? 'Folder' : 'Project',
        lower: isNestedProjectsOn ? 'folder' : 'project',
      }) as const,
    [isNestedProjectsOn]
  )
}

export type FolderTerm = ReturnType<typeof useFolderTerm>
